import React from 'react'
import { FlagIcon, FlagWrapper } from './style'
import { ELanguage } from 'types/enums/ELanguage'
import { useDispatch } from 'react-redux'
import { setLanguage } from 'store/reducers/layoutReducer'

type Props = {
  flagImagePath: string
  language: ELanguage
  onClick?: () => void
}

const Flag: React.FC<Props> = ({ flagImagePath, language, onClick }) => {
  const dispatch = useDispatch()
  return (
    <FlagWrapper className="flagIcon">
      <FlagIcon
        src={flagImagePath}
        alt="Flag Icon"
        onClick={() => (onClick ? onClick() : dispatch(setLanguage(language)))}
      />
    </FlagWrapper>
  )
}

export default Flag
